module.exports = __webpack_public_path__ + "static/media/Event-Analytics.beca2b70.png";